import { createContext, useContext, useEffect, useState } from 'react';

const ThemeCtx = createContext({ theme: 'dark', toggle: () => {} });

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('dark');

    useEffect(() => {
        // Read saved preference (default dark)
        const saved = localStorage.getItem('ht-theme');
        const initial = saved === 'light' ? 'light' : 'dark';
        setTheme(initial);
    }, []);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('ht-theme', theme);
    }, [theme]);

    const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

    return (
        <ThemeCtx.Provider value={{ theme, toggle }}>{children}</ThemeCtx.Provider>
    );
};

export const useTheme = () => useContext(ThemeCtx);
